import { render, staticRenderFns } from "./forget-password.vue?vue&type=template&id=2f00542a&"
import script from "./forget-password.vue?vue&type=script&lang=js&"
export * from "./forget-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ForgetPassword: require('/Users/eralpsoftwareweb/Desktop/Active Projects/Heocademy/Gökçe Özel/gokce-ozel-nuxt/components/ForgetPassword/index.vue').default})
